import { createIcon } from './createIcon';

const BusRoutes = createIcon(
  'BusRoutes',
  <>
    <rect
      x="4"
      y="4"
      width="16"
      height="14"
      rx="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4 10H20" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="7.5" cy="15" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="16.5" cy="15" r="1.5" fill="currentColor" stroke="none" />
    <path d="M8 21L12 18L16 21" strokeLinecap="round" strokeLinejoin="round" />
  </>,
);

export default BusRoutes;
